import { createContext, useState } from "react";

const DisableContext = createContext({});

const DisableContextProvider = ({ children }) => {
  const [disableParty, setDisableParty] = useState(false);
  const [disableItemMaster, setDisableItemMaster] = useState(false);
  const [disableIndentCreate, setDisableIndentCreate] = useState(false);
  const [disableDirectPOCreate, setDisableDirectPOCreate] = useState(false);
  return (
    <DisableContext.Provider value={{ disableParty, setDisableParty, disableItemMaster, setDisableItemMaster, disableIndentCreate, setDisableIndentCreate, disableDirectPOCreate, setDisableDirectPOCreate }}>
      {children}
    </DisableContext.Provider>
  );
};

export { DisableContext, DisableContextProvider };
